// extracted by mini-css-extract-plugin
export default {"dnbHeaderControls":"HeaderControls-module--dnbHeaderControls--6df6a"};